import React, { Component } from 'react';
import HtmlToReact from 'html-to-react';

/**
* @memberof Blocking
* @extends Component
* @classdesc (Component) This component renders a single words and manages the
* Click and Hover event handlers.
* @prop {object} htmlToReact - (local) Parses any html markup from the database text
* @prop {object} index - (prop) the associated line and word number
* @prop {object} actions - (prop) Group of callbacks to manage state and BlockID
* @prop {object} blockID - (props) the blockID of the word
* @prop {boolean} marked - (props) whether this word is marked or not
* @prop {boolean} hover - (props) whether this word is being hovered over or not
*/

class WordBlocking extends Component {
  /** Sets the html parser */
  componentWillMount(){
    this.htmlToReact = new HtmlToReact.Parser();
  }

  /**
  * Click event handler, toggles the marked state
  * (add/remove) and also handles the offsetLeft value
  */
  onClick(){
    if(!this.props.marked){
      const offsetLeft = this.ref.offsetWidth + this.ref.offsetLeft;
      this.props.actions.addMarked(this.props.index, offsetLeft);
    }else if(this.props.marked){
      this.props.actions.removeMarked(this.props.index);
    }
  }

  /**
  * Hover event handler, toggles the hover state
  * triggers max every 1000ms
  */
  onMouseEnter(){
    if(this.props.marked)
      return;
    this.timeOut = setTimeout(() => {
      this.props.actions.toggleHover(this.props.index);
      this.timeOut = null;
    }, 1000);
  }

  /**
  * Hover event handler, Removes hover and
  * clears timer on mouse leave
  */
  onMouseLeave(){
    if(this.timeOut){
      clearTimeout(this.timeOut);
      return;
    }

    if(this.props.hover)
      this.props.actions.toggleHover(null);
  }

  /**
   * Renders a word in a < span>. Adds classname based
   * on blockID, marked, and hover.
   */
  render(){
    const parity = this.props.blockID % 2 === 0 ? 'even' : 'odd';
    let word,
        className = ['blocking'];

    if(this.props.marked)
      className.push('marked');
    else if(this.props.hover)
      className.push('hover');

    if(parity)
      className.push(parity);

    if(this.props.index.word === 1)
      word = this.htmlToReact.parse('<span>' +this.props.word + '</span>');
    else
      word = this.htmlToReact.parse('<span>&nbsp;' +this.props.word + '</span>');

    return (
      <span
        ref = {(ref) => {this.ref = ref}}
        onClick = {() => this.onClick()}
        className = {className.join(' ')}
        onMouseEnter = {() => this.onMouseEnter()}
        onMouseLeave = {() => this.onMouseLeave()}
      >
        {word}
      </span>
    )
  }
}

export default WordBlocking;



// WEBPACK FOOTER //
// ./src/components/Blocking/WordBlocking.js